import { useState } from "react";
import { Form, Input, InputNumber, Typography, DatePicker, Select, Popconfirm } from 'antd';
import moment from 'moment';

interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
    editing: boolean;
    dataIndex: string;
    title: any;
    inputType: 'number' | 'text' | 'date' | 'datetime' | 'select';
    record: any;
    index: number;
    valueEnum?: any;
    children: React.ReactNode;
    width: number;
}

export const EditableCell: React.FC<EditableCellProps> = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    valueEnum,
    children,
    width,
    ...restProps
}) => {
    let inputNode = null;
    if (inputType === 'number') {
        inputNode = <InputNumber />
    }
    else if (inputType === 'date') {
        inputNode =
            <DatePicker
                allowClear={false}
                defaultValue={moment(record[dataIndex], 'YYYY-MM-DD')}
                format="YYYY-MM-DD" />
    }
    else if (inputType === 'datetime') {
        inputNode =
            <DatePicker
                showTime
                allowClear={false}
                defaultValue={moment(record[dataIndex], 'YYYY-MM-DD HH:mm:ss')}
                format="YYYY-MM-DD HH:mm:ss" />
    }
    else if (inputType === 'select') {
        inputNode =
            <Select
                style={{ width: width }}
                showSearch
                filterOption={(input, option) =>
                    (option?.label ?? '').toString().indexOf(input) >= 0
                }
                options={valueEnum} />
    }
    else {
        inputNode = <Input />
    }
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{ margin: 0 }}
                    rules={[
                        {
                            required: true,
                            message: `请输入 ${title}!`,
                        },
                    ]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};

export interface EditTableRowPropsType {
    keyName: string;
    cols: any;
    saveMethod: (key: string) => Promise<boolean>;
    deleteMethod: (key: string) => Promise<boolean>;
    editMethod: (r: any) => boolean;
}

export const MergedColumns = (props: EditTableRowPropsType) => {

    const [editingKey, setEditingKey] = useState<string>('');
    const isEditing = (key: string) => key === editingKey;

    const saveMethod = async (key: string) => {
        let ret = await props.saveMethod(key)
        if (ret) {
            setEditingKey('')
        }
    };

    const deleteMethod = async (key: string) => {
        let ret = await props.deleteMethod(key)
        if (ret) {
            setEditingKey('')
        }
    };

    const editMethod = async (r: any) => {
        let ret = await props.editMethod(r)
        if (ret) {
            setEditingKey(props.keyName)
        }
    };

    const newColumns = [
        ...props.cols,
        {
            title: '操作',
            dataIndex: 'operation',
            width: 100,
            align: 'center' as const,
            inputType: null,
            valueEnum: null,
            editable: false,
            render: (v: any, r: any, i: number) => {
                const editable = isEditing(props.keyName);
                return editable ?
                    (
                        <span>
                            <Typography.Link style={{ marginRight: 8 }} onClick={() => saveMethod(r.id)}>
                                保存
                            </Typography.Link>
                            <Typography.Link style={{ marginRight: 8 }} onClick={() => setEditingKey('')}>
                                取消
                            </Typography.Link>
                        </span>
                    ) :
                    (
                        <span>
                            <Typography.Link style={{ marginRight: 8 }} disabled={editingKey !== ''} onClick={() => editMethod(r)}>
                                编辑
                            </Typography.Link>
                            <Popconfirm title="确认删除吗?" onConfirm={() => deleteMethod(r.id)}>
                                <a>删除</a>
                            </Popconfirm>
                        </span>
                    );
            },
        },
    ];

    const mergedColumns = newColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record: any) => ({
                record,
                inputType: col.inputType,
                dataIndex: col.dataIndex,
                title: col.title,
                valueEnum: col.valueEnum,
                editing: isEditing(props.keyName),
            }),
        };
    });

    return mergedColumns;
}








